import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home         from "./pages/Home.jsx";
import Services     from "./pages/Services.jsx";
import Industries   from "./pages/Industries.jsx";
import AIAssessment from "./pages/AIAssessment.jsx";
import About        from "./pages/About.jsx";
import Resources    from "./pages/Resources.jsx";
import Contact      from "./pages/Contact.jsx";

// Scroll to top on every page navigation
function ScrollToTop() {
  const { pathname } = window.location;
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/services"      element={<Services />} />
        <Route path="/industries"    element={<Industries />} />
        <Route path="/ai-assessment" element={<AIAssessment />} />
        <Route path="/about"         element={<About />} />
        <Route path="/resources"     element={<Resources />} />
        <Route path="/contact"       element={<Contact />} />
        {/* Let /downloads/* pass through to static files */}
        <Route path="/downloads/*"   element={null} />
        {/* Fallback to home */}
        <Route path="*"              element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}